import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class ProvidersAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // token = getTokenLocal();

  specialities = ApiRoutes.Providers.Specialities
  providers = ApiRoutes.Providers.Providers
  providerMetrics = ApiRoutes.Providers.ProviderMetrics
  providerData = ApiRoutes.Providers.ProviderData

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getSpecialities = (token: string) => {
    return this.instance({
      method: this.specialities.Method,
      url: this.specialities.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getProviders = (token: string, practices: any, speciality: any) => {
    return this.instance({
      method: this.providers.Method,
      url: this.providers.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        speciality: speciality,
        practice_list: practices,
      },
    })
  }

  getProviderMetricsBySpeciality = (token: string, metricBucketId: any) => {
    return this.instance({
      method: this.providerMetrics.Method,
      url: this.providerMetrics.EndPoint(metricBucketId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: null,
    })
  }

  getProvidersData = (
    token: string,
    groups: any,
    practices: any,
    providers: any,
    metrics: any,
  ) => {
    return this.instance({
      method: this.providerData.Method,
      url: this.providerData.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_list: groups,
        practice_list: practices,
        provider_list: providers,
        metric_list: metrics,
      },
    })
  }
}
